import { Map, fromJS } from "immutable";
import * as CONST from "actions/action_constants";

const kioskAppVersions = (state = Map({}), action) => {
  switch (action.type) {
    case CONST.KIOSK_APP_VERSIONS_FETCH_SUCCESS:
      return fromJS(action.versions);
    default:
      return state;
  }
};

export default kioskAppVersions;
